export default "__VITE_ASSET__4rEnGRU4__"